import { orderExplorerRootStore } from './order-explorer-root-store';

const useOrderExplorerStore = () => orderExplorerRootStore.getStore();

export default useOrderExplorerStore;
